import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from './cx';
import s from './Card.module.css';

export interface CardProps extends HTMLAttributes<HTMLElement> {
  as?: 'div' | 'section' | 'article';
  padding?: 'none' | 'md' | 'lg';
  tone?: 'default' | 'dark';
}

export function Card({ as: Tag = 'div', padding = 'md', tone = 'default', className, ...rest }: CardProps) {
  return <Tag className={cx(s.card, s[`p-${padding}`], tone === 'dark' && s.dark, className)} {...rest} />;
}

export interface CardHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
}

export function CardHeader({ title, description, actions }: CardHeaderProps) {
  return (
    <div className={s.header}>
      <div className={s.headerText}>
        <h3 className={s.title}>{title}</h3>
        {description && <p className={s.description}>{description}</p>}
      </div>
      {actions && <div className={s.actions}>{actions}</div>}
    </div>
  );
}
